import { Creator } from 'src/domain/creator';
import { Organization } from 'src/domain/organization';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
import { CreatorProfile } from './CreatorProfile';
import { NextOfKin } from 'src/domain/next-of-kin';
import { NextofkinProfile } from './NextofkinProfile';
import { OrganizationProfile } from './OrganizationProfile';
import { Admin } from 'src/domain/admin';
import { AdminProfile } from './AdminProfile';
import { getPrimaryRole, isUserAdmin, UserRole } from 'src/domain/user';

export const MyProfile = () => {
    const user = useSignedInUser();
    const role = getPrimaryRole(user);
    if (!user) return null;

    if (isUserAdmin(user)) {
        return <AdminProfile user={user as unknown as Admin} />;
    }

    switch (role) {
        case UserRole.organization:
        case UserRole.organizationB2C:
            return (
                <>
                    <OrganizationProfile
                        user={user as Organization}
                        readOnly={Boolean(user?.supportMode)}
                    />
                </>
            );
        case UserRole.creator:
            return (
                <>
                    <CreatorProfile user={user as Creator} />
                </>
            );
        case UserRole.nextOfKin:
            return (
                <>
                    <NextofkinProfile user={user as NextOfKin} />
                </>
            );
        default:
            return null;
    }
};
